const bagWeightLimit = {
  airWeight : 20.0,
  surfaceWeight : 25.0,
};
export default bagWeightLimit;
